export function uniqueId() {
	return crypto.randomUUID?.() ?? Math.random()
}
